import React from 'react';

const products = [
  {
    icon: 'hub',
    title: 'The Hub',
    status: 'Coming Soon',
    description:
      'Where digital work gets posted, matched, managed, and completed. Every type. Every skill. One platform.',
  },
  {
    icon: 'business_center',
    title: 'Business Tools',
    status: 'Coming Soon',
    description:
      'The operational layer businesses need, built modularly so you only pay for what you actually use.',
  },
  {
    icon: 'api',
    title: 'API & Integrations',
    status: 'Coming Soon',
    description:
      'Plug 200 OK capabilities directly into your own systems. Build on top of what we build.',
  },
];

const Features = () => {
  return (
    <section className="features" id="products">
      <div className="features__header reveal">
        <div className="features__label">
          <span
            className="material-symbols-outlined"
            style={{ fontSize: '0.85rem' }}
          >
            rocket_launch
          </span>
          {'// WHAT WE\'RE LAUNCHING'}
        </div>
        <h2 className="features__heading">
          One ecosystem. Multiple products. All built to make digital work
          actually work.
        </h2>
        <p className="features__subheading">
          We're not building one thing. We're building the platform we always
          wished existed, then the tools that make running a business on top of
          it seamless.
        </p>
      </div>

      <div className="products__grid">
        {products.map((product, index) => (
          <div
            className={`product-card reveal reveal-delay-${index + 1}`}
            key={index}
          >
            <div className="product-card__lock">
              <span className="material-symbols-outlined">lock</span>
            </div>
            <div className="product-card__icon">
              <span className="material-symbols-outlined">
                {product.icon}
              </span>
            </div>
            <h3 className="product-card__title">{product.title}</h3>
            <span className="product-card__status">{product.status}</span>
            <p className="product-card__description">
              {product.description}
            </p>
          </div>
        ))}
      </div>

      <p className="features__tagline reveal">
        More will be revealed closer to launch.{' '}
        <a href="#waitlist">Get on the waitlist</a> to be the first to know
        what's inside.
      </p>
    </section>
  );
};

export default Features;
